exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-primary[data-v-a03f095e] {\n  background-color: #822023 !important;\n}\n.property-label[data-v-a03f095e] {\n  font-size: 11pt;\n  font-weight: 400;\n}\n.property-label-caption[data-v-a03f095e] {\n  font-size: 12pt;\n  font-weight: 600;\n}\n.text-dark[data-v-a03f095e] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a03f095e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/dashboard/Dashboard.vue
// module id = 686
// module chunks = 1